<template>
    <IntegrationPage/>
</template>
<script>
 import IntegrationPage from "../pages/IntegrationPage.vue";

export default {
    components: {
        IntegrationPage
    },

}
</script>
<style scoped lang="scss">

</style>
